import React from 'react';
import { useStateValue } from 'context/store';
import { updateAcceptanceOfTermsAndConditions } from 'context/settings/companyRegister/actions';
import TermsAndConditionsForm from './TermsAndConditionsForm';

const TermsAndConditions = ({ termsStatus, companyId, includeCompanyChange }) => {
  const termsForEvaluate = {};
  Object.entries(termsStatus).forEach(([key, value]) => {
    termsForEvaluate[key] = value;
  });

  const [{commons:{loading}},dispatch] = useStateValue();

  const onSubmit = async(data) => {
    const termsPromise = []
    const payload = includeCompanyChange ? { ...data, has_accepted_company_change: true } : data;
    companyId && termsPromise.push(updateAcceptanceOfTermsAndConditions(dispatch, { ...payload, companyId }))
    Promise.all([
      ...termsPromise
    ]).then(() => {
      window.location.reload();
    });
  };

  return (
    <TermsAndConditionsForm
    termsForEvaluate={termsForEvaluate}
      onSubmitTermsAndConditions={onSubmit}
      isLoading={loading}
    />
  );
};

export default TermsAndConditions;
